import * as RowNotificationHandler from './rowNotificationHandler';
import getConversationSortByProperty from '../../utils/tables/getConversationSortByProperty';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import * as findConversationShapeUtil from 'owa-mail-store/lib/services/utils/findConversationShapeUtil';
import { trace } from 'owa-trace';
import { action, select } from 'satcheljs/lib/legacy';
import { lazyGetChannelId, lazySubscribe, lazyUnsubscribe, } from 'owa-notification';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import { isFolderOfTreeType, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';
var tableIdToSubscriptionMap = {};
export var handleRowNotification = select({
    tableView: function (notification) {
        return listViewStore.tableViews.get(notification.id);
    },
})(action('handleRowNotification')(function handleRowNotifications(notification, state) {
    var tableView = state.tableView;
    if (!tableView) {
        // if folder is deleted and we receive a notification, which can happen when
        // there are pending notifications for this folder, we don't handle them and just return
        trace.info('Received row notification for a deleted folder');
        return;
    }
    if (!tableView.isInitialLoadComplete) {
        // Do not process the notifications until the initial table load is complete.
        // We do this because we subscribe to the table notifications first and then
        // issue a findConversation call.
        trace.info('Ignore row notifications as table has not loaded');
        return;
    }
    var rowData;
    switch (notification.EventType) {
        case 'RowAdded':
            rowData = getRowDataFromRowNotification(notification, tableView);
            RowNotificationHandler.onAddRow(rowData, tableView);
            break;
        case 'RowModified':
            rowData = getRowDataFromRowNotification(notification, tableView);
            RowNotificationHandler.onUpdateRow(rowData, tableView);
            break;
        case 'RowDeleted':
            rowData = getRowDataFromRowNotification(notification, tableView);
            RowNotificationHandler.onDeleteRow(rowData, tableView);
            break;
        case 'QueryResultChanged':
        case 'Reload':
            RowNotificationHandler.onReload(tableView);
            break;
        default:
            // Ignore other type of notifications
            return;
    }
}));
export function unsubscribeToRowNotifications(tableId) {
    var subscription = tableIdToSubscriptionMap[tableId];
    if (subscription) {
        // unsubscribe this subscription
        lazyUnsubscribe.importAndExecute(subscription, handleRowNotification);
        delete tableIdToSubscriptionMap[tableId];
    }
}
export function subscribeToRowNotifications(tableView) {
    // do not subscribe if we have existing subscription
    if (tableIdToSubscriptionMap[tableView.id]) {
        return;
    }
    if (tableView.tableQuery.type != 0 /* Folder */ &&
        tableView.tableQuery.type != 2 /* Group */) {
        throw new Error('subscribeToRowNotifications should only be called for Folder or Group table type');
    }
    var mailFolderTableQuery = tableView.tableQuery;
    // VSO: 18945 - Add notification support for the multivalued sort
    // Till then only support date time sort
    // Also we do not subscribe to notification if the folder is under archive mailbox or shared folders
    if (mailFolderTableQuery.sortBy.sortColumn != 0 /* Date */ ||
        isFolderUnderArchiveRoot(tableView.tableQuery.folderId) ||
        isFolderOfTreeType(tableView.tableQuery.folderId, SHARED_FOLDERS_TREE_TYPE)) {
        return;
    }
    lazyGetChannelId.import().then(function (getChannelId) {
        var subscriptionParameters = {
            NotificationType: 'RowNotification',
            FolderId: getFolderIdForSubscription(tableView),
            FocusedViewFilter: mailFolderTableQuery.focusedViewFilter,
            SortBy: getConversationSortByProperty(mailFolderTableQuery),
            IsConversation: mailFolderTableQuery.listViewType == 0 /* Conversation */,
            Filter: mailFolderTableQuery.viewFilter,
            ChannelId: getChannelId(),
            MailboxId: getMailboxIdForSubscription(tableView),
        };
        if (subscriptionParameters.IsConversation === true) {
            subscriptionParameters.ConversationShapeName = findConversationShapeUtil.getFindConversationShape(tableView.tableQuery.folderId);
            subscriptionParameters.ConversationResponseShape = findConversationShapeUtil.getFindConversationResponseShape(tableView.tableQuery.folderId);
        }
        var subscription = {
            subscriptionId: tableView.id,
            requiresExplicitSubscribe: true,
            subscriptionParameters: subscriptionParameters,
        };
        // subscribe and store the subscription object
        lazySubscribe.importAndExecute(subscription, handleRowNotification);
        tableIdToSubscriptionMap[tableView.id] = subscription;
    });
}
function getFolderIdForSubscription(tableView) {
    return tableView.tableQuery.type == 0 /* Folder */
        ? tableView.tableQuery.folderId
        : null;
}
function getMailboxIdForSubscription(tableView) {
    return tableView.tableQuery.type == 2 /* Group */ ? tableView.tableQuery.folderId : null;
}
function getRowDataFromRowNotification(notification, tableView) {
    // Make sure the notification payload has the correct data type
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            if (notification.Conversation) {
                return notification.Conversation;
            }
            else {
                trace.error('Conversation should not be undefined or empty in notification payload.' +
                    notification.EventType +
                    ', ' +
                    notification.id);
                return null;
            }
        case 1 /* Message */:
            if (notification.Item) {
                return notification.Item;
            }
            else {
                trace.error('Item should not be undefined or empty in notification payload.' +
                    notification.EventType +
                    ', ' +
                    notification.id);
                return null;
            }
        default:
            trace.error('rowNotificationStrategy: unsupported listViewType: ' +
                tableView.tableQuery.listViewType);
            return null;
    }
}
//# sourceMappingURL=rowNotificationsStrategy.js.map